import * as _ from 'lodash';
import moment from 'moment';
import type { VoidFunctionComponent } from 'react';
import type { Column } from 'react-table';

import { BUTTON_SIZE, BUTTON_TYPE, NavigationButton } from '../../../generic';
import Flex from '../../../generic/Flex';
import Loader from '../../../generic/Loader';
import SimpleReactTable from '../../../generic/SimpleReactTable';
import TableHeader from '../../../generic/TableHeader';
import Text from '../../../generic/Text';
import type { StripeInvoice } from '../../../../../typings/stripe';

import useInvoiceHistory from './useInvoiceHistory';

import styles from '../style.module.less';

const getColumns = (): Array<Column<any>> => {
  return [
    {
      id: 'invoice',
      Header: <TableHeader title="Invoice" />,
      accessor: 'invoice',
      resizable: false,
      style: {
        textOverflow: 'ellipsis',
      },
    },
    {
      id: 'date',
      Header: <TableHeader title="Date" />,
      accessor: 'date',
      resizable: false,
      style: {
        textOverflow: 'ellipsis',
      },
    },
    {
      id: 'amount',
      Header: <TableHeader title="Amount" />,
      accessor: 'total',
      resizable: false,
      style: {
        textOverflow: 'ellipsis',
      },
    },
    {
      id: 'link',
      Header: <TableHeader title="" />,
      accessor: 'link',
      resizable: false,
      style: {
        textOverflow: 'ellipsis',
      },
    },
  ];
};

const formattedData = (invoices: StripeInvoice[]) => {
  const length = invoices.length;
  return invoices.map((invoice, idx) => {
    return {
      invoice: `Invoice #${length - idx}`,
      total: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(invoice.total / 100),
      date: moment(invoice.created * 1000)
        .format('MMM YYYY')
        .toString(),
      link: (
        <div className={styles.invoiceHistoryLinkContainer}>
          <NavigationButton
            to={invoice.hosted_invoice_url}
            type={BUTTON_TYPE.OUTLINE}
            size={BUTTON_SIZE.SMALL}
            openInNewTab
          >
            View Invoice
          </NavigationButton>
        </div>),
    };
  });
};

const InvoiceHistory: VoidFunctionComponent = () => {
  const {
    data,
    isLoading,
  } = useInvoiceHistory();

  if (isLoading) {
    return (<Loader />);
  }

  if (!data) {
    return null;
  }

  if (_.isEmpty(data)) {
    return (
      <Flex>
        <Text.H2>No invoices found.</Text.H2>
      </Flex>);
  }

  return (
    <SimpleReactTable
      data={formattedData(data)}
      columns={getColumns()}
      defaultSortMode={[]}
      isSortable={false}
    />
  );
};

export default InvoiceHistory;
